module.exports = __webpack_public_path__ + "img/success.8a60bb8a.svg";